/**
 * Asynchronously loads the component for NoticePage
 */

import { lazyLoad } from "@utils/loadable";

export const NoticeArticlePage = lazyLoad(
  () => import("./index"),
  (module) => module.NoticeArticlePage
);
